import { keyframes } from '@emotion/react';

export const arrowAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px);
  }
  100% {
    transform: translateX(0);
  }
`;
export const upDown = keyframes`
  0%, 100% {
    transform: translateY(-15px);
  }
  50% {
    transform: translateY(15px);
  }
`;

export const leftRight = keyframes`  
  0%, 100% { 
    transform: translateX(-15px);  
  } 
  50% { 
    transform: translateX(15px);
  } 
`;

export const leafMoveLeft = keyframes`
  0% { transform: translateX(0); opacity: 1; }
  100% { transform: translateX(-100%); opacity: 0; }
`;

export const leafMoveRight = keyframes`
  0% { transform: translateX(0); opacity: 1; }
  100% { transform: translateX(100%); opacity: 0; }
`;

export const floatRotateAnimation = keyframes`
  0% {
    transform: rotate(180deg) scale(1.1);
  }
  50% {
    transform: rotate(180deg) scale(1); 
  }
  100% {
    transform: rotate(180deg) scale(1.1);
  }
`;

export const floatAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

export const doorSwing = keyframes`
  0% {
    transform: rotateY(0deg) translateY(0);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  }
  50% {
    transform: rotateY(-5deg) translateY(-5px);
    box-shadow: 0 25px 40px rgba(0,0,0,0.15);
  }
  100% {
    transform: rotateY(0deg) translateY(0);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
  }
`;

export const frameGlow = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;
export const kenBurns = keyframes`
  0% {
    transform: scale(1) translateX(0) translateY(0);
  }
  50% {
    transform: scale(1.1) translateX(-5%) translateY(-3%);
  }
  100% {
    transform: scale(1) translateX(0) translateY(0);
  }
`;

export const textAnimation = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

export const buttonAnimation = {
  hidden: { opacity: 0, scale: 1.2 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// animations.js
export const containerAnimation = {
  hidden: { opacity: 0, y: -50, scale: 0.95 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 1.2,
      ease: 'easeOut',
      when: 'beforeChildren',
      staggerChildren: 0.4, // لتأخير دخول كل عنصر بعد الآخر
    },
  },
};

export const imageAnimation = {
  hidden: { opacity: 0, scale: 1.2, rotate: 10 },
  show: {
    opacity: 1,
    scale: 1,
    rotate: 0,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// تأثير دخول العنوان الفرعي من اليسار
export const textAnimationFromLeft = {
  hidden: { opacity: 0, x: -50, scale: 0.9 },
  show: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// تأثير دخول العنوان الرئيسي من اليمين
export const textAnimationFromRight = {
  hidden: { opacity: 0, x: 50, scale: 0.9 },
  show: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// تأثير دخول الوصف من الأسفل
export const textAnimationFromBottom = {
  hidden: { opacity: 0, y: 50, scale: 0.9 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// تأثير دخول الزر من الأعلى (يمكنك تغييره حسب رغبتك)
export const buttonAnimationFromTop = {
  hidden: { opacity: 0, y: -50, scale: 0.8 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 1.2, ease: 'easeOut' },
  },
};

// الأنيميشنات القديمة أو الإضافية إذا احتجت إليها تبقى هنا...
export const advancedRotationAnimation = {
  hidden: { opacity: 0, rotate: -15 },
  show: {
    opacity: 1,
    rotate: 0,
    transition: { duration: 1.5, ease: 'easeOut' },
  },
};

export const cardVariants = {
  // حالة البداية: تخفّي، تصغير مع نزول خفيف وتدوير طفيف
  hidden: { opacity: 0, scale: 0.7, y: 20, rotate: -10 },
  // الحالة الظاهرة: زيادة الشفافية إلى 1، تكبير للقياس الطبيعي مع إعادة الوضع الأصلي، باستخدام انتقال spring
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    rotate: 0,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
  },
  // تأثير hover: تكبير بسيط مع تدوير طفيف متتابع لإضفاء حيوية عند تحريك الماوس
  hover: {
    scale: 1.05,
    rotate: [0, 3, -3, 0],
    transition: { type: 'spring', stiffness: 300, damping: 10 },
  },
};

// تأثير انزلاق وتلاشي عناوين القسم
export const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 1, ease: 'easeOut' },
  },
};

// تأثير جديد لبطاقة الحدث
export const eventCardVariant = {
  hidden: { opacity: 0, scale: 0.8, y: 50 },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 20 },
  },
  hover: {
    scale: 1.03,
    rotate: [0, 2, -2, 0],
    transition: { duration: 0.8, ease: 'easeInOut' },
  },
};

// تعريف متغيرات الحاوية (Container Variants)
export const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15, // تأخير بسيط 0.15 ثانية بين كل بطاقة
    },
  },
};

// تعريف متغيرات بطاقة الحدث (Card Variants)
export const cardVariant = {
  hidden: { opacity: 0, y: 30, scale: 0.9 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.7, ease: 'easeOut' },
  },
  hover: {
    scale: 1.08,             // تكبير طفيف
    rotate: [0, 5, -5, 0],    // دوران متتابع لإضفاء حركة إضافية
    transition: { duration: 0.8, ease: 'easeInOut' },
  },
};